export class Personne {

  public civility: string;
  public dateNaissance: string;
  public isFumeur: boolean;
  public profession: any;
  public isTravailManuel: boolean;
  public isTravailEnHauteur: boolean;
  public isDeplacements: boolean;
  public regimeSocial: any;
  public paysDeResidence: any;
  public nationalite: any;
  public status: any;
  public affiliation: any;
  public quotite: number;
  public nom: string;
  public prenom: string;
  public telephone: string;
  public email: string;
  public adresse: string;
  public ville: string;
  public codePostal: string;
  public professionExacte: string;
  public voyage: string;
  public encourslemoine = {code: 'UNKOWN', label: 'Je ne sais pas'};
}



// WEBPACK FOOTER //
// ./src/app/personne.ts